import type React from "react";

import { useUser } from "../../../hooks";

interface AuthorizedCommonProps {
	readonly permissions: string | string[];
}

interface AuthorizedWithoutFallbackProps extends AuthorizedCommonProps {
	readonly children: React.ReactNode;
	readonly fallback?: never;
}

interface AuthorizedWithFallbackProps extends AuthorizedCommonProps {
	readonly children?: React.ReactNode;
	readonly fallback: React.ReactNode;
}

type AuthorizedProps = AuthorizedWithoutFallbackProps | AuthorizedWithFallbackProps;

export const Authorized: React.FC<AuthorizedProps> = ({ children = null, permissions, fallback = null }) => {
	const { hasAnyRole } = useUser();

	const matchedRoles = hasAnyRole(Array.isArray(permissions) ? permissions : [permissions]);

	if (matchedRoles === undefined) {
		return null;
	}

	if (matchedRoles) {
		return children;
	}

	return fallback;
};
